import { mediaApi } from "../../api/endpoints";

// Editöre yapıştırılan / sürüklenen görseller, form kaydedilene kadar yalnızca
// tarayıcıda tutulur. Editörde görünen `blob:` adresi geçici bir önizlemedir.
// "Kaydet" anında uploadPendingImages() çağrılır: dosyalar MinIO'ya yüklenir ve
// HTML içindeki blob: adresleri gerçek medya URL'i ile değiştirilir.
//
// Böylece vazgeçilen yazılardan storage'da yetim dosya kalmaz.
//
// Kayıt yarıda kalırsa (bir görselin ya da formun kendisinin kaydı başarısız
// olursa) yüklenen görsellerin URL'leri `uploaded` içinde saklanır ve blob
// dosyaları silinmez: tekrar denemede yüklenmiş olanlar yeniden yüklenmez,
// yüklenmemiş olanlar hâlâ elde olur. Kayıt tamamen başarılı olunca
// releasePendingImages() ile blob'lar serbest bırakılır.

const pending = new Map<string, File>();
const uploaded = new Map<string, string>();

const BLOB_SRC = /src="(blob:[^"]+)"/g;

// Dosyayı beklemeye alır, editöre konulacak geçici önizleme adresini döner.
export function registerPendingImage(file: File): string {
  const url = URL.createObjectURL(file);
  pending.set(url, file);
  return url;
}

export function countPendingImages(html: string): number {
  const urls = new Set(Array.from(html.matchAll(BLOB_SRC), (m) => m[1]));
  return Array.from(urls).filter((u) => !uploaded.has(u)).length;
}

// HTML'deki tüm blob: görselleri yükler ve gerçek URL'leriyle değiştirilmiş
// HTML'i döner. Yazıdan silinmiş görseller yüklenmez; daha önceki (başarısız)
// bir kayıt denemesinde yüklenmiş görseller tekrar yüklenmez.
export async function uploadPendingImages(html: string, folder: string): Promise<string> {
  const urls = Array.from(new Set(Array.from(html.matchAll(BLOB_SRC), (m) => m[1])));
  let result = html;

  for (const blobUrl of urls) {
    let realUrl = uploaded.get(blobUrl);
    if (!realUrl) {
      const file = pending.get(blobUrl);
      if (!file) {
        // Sayfa yenilenmiş ya da dosya düşmüş olabilir: sessizce boş URL kaydetmek
        // yerine kullanıcıya haber ver.
        throw new Error("Yapıştırılan görsellerden biri kayboldu. Lütfen tekrar ekleyin.");
      }
      const { data } = await mediaApi.upload(file, undefined, folder);
      realUrl = data.url;
      uploaded.set(blobUrl, realUrl);
    }
    result = result.split(blobUrl).join(realUrl);
  }

  return result;
}

// Kayıt başarıyla tamamlandıktan sonra çağrılır: yüklenmiş görsellerin blob
// önizlemelerini serbest bırakır.
export function releasePendingImages(): void {
  for (const blobUrl of uploaded.keys()) {
    pending.delete(blobUrl);
    URL.revokeObjectURL(blobUrl);
  }
  uploaded.clear();
}
